import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { RawUser } from "../../../../domain/user";
import { AbstractControl, NgForm } from "@angular/forms";
import { TenantRepository } from "../../../../domain/tenant-repository";
import { Tenant } from "../../../../domain/tenant";
import moment from "moment";
import { UserRepository } from "../../../../domain/user-repository";
import { EditUserViewModel } from "../../ViewModels/EditUserViewModel";

@Component({
  selector: "user-form",
  templateUrl: "./user-form.component.html",
  styleUrls: ["./user-form.component.scss"],
})
export class UserFormComponent implements OnInit {
  @Input()
  userVM: EditUserViewModel;

  @ViewChild("userForm") form: NgForm;

  /*@Input()
    user: RawUser;

    @Input()
    allTenants: Array<Tenant>;

    @Output()
    onResetClicked = new EventEmitter();

    @Output()
    onFormSubmitted = new EventEmitter<RawUser>();

    @Input()
    showPasswordFields = false;


    choosenTab = 'personal';


    submitForm = new EventEmitter();*/

  constructor() {}

  ngOnInit(): void {}
}
